<template>
    <div class="row">
        <div class="col-xl-8 col-lg-8 col-md-10 col-sm-10 mx-auto form p-1">
            <div v-if="payload" class="alert alert-success" role="alert">
                Дані успішно збережені!
            </div>
            <div v-if="error" class="alert alert-danger" role="alert">
                Помилка при збереженні даних
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="form-group">
                        <label>
                            <strong>Email админа по трансформаторам</strong>
                        </label>
                        <input
                            name="email"
                            type="text"
                            v-model="model.email"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Email админа по шинопроводу</strong>
                        </label>
                        <input
                            name="email2"
                            type="text"
                            v-model="model.email2"
                            class="form-control"
                        >
                    </div>
                    <div class="form-group mt-2">
                        <label>
                            <strong>"Опитувальний лист" WORD масляный трансформатор</strong>
                        </label>
                        <input type="file" class="form-control" v-on:change="onFileChange">
                    </div>
                    <div class="form-group mt-2 mb-1">
                        <a :href="model.file" target="_blank" class="file">
                            {{ model.file }} <i class="pi pi-file"></i>
                        </a>
                    </div>
                    <div class="form-group mt-2">
                        <label>
                            <strong>"Опитувальний лист" WORD сухий трансформатор</strong>
                        </label>
                        <input type="file" class="form-control" v-on:change="onFile2Change">
                    </div>
                    <div class="form-group mt-2 mb-1">
                        <a :href="model.file2" target="_blank" class="file">
                            {{ model.file2 }} <i class="pi pi-file"></i>
                        </a>
                    </div>
                    <div class="form-group mt-2">
                        <label>
                            <strong>“Технічна інформація” по шинопроводу</strong>
                        </label>
                        <input type="text" class="form-control" v-model="model.bus_bar">
                    </div>
                </div>
            </div>
            <div class="text-right">
                <button
                    type="submit"
                    class="btn btn-primary"
                    @click.prevent="update"
                >
                    Сохранить
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import Menubar from "primevue/menubar";
import Column from "primevue/column";
import Row from "primevue/row";
import ColumnGroup from "primevue/columngroup";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import AutoComplete from "primevue/autocomplete";
import axios from "axios";
import DeleteConfirmation from '../mixins/components/delete.vue';
import "bootstrap/dist/css/bootstrap.min.css"

export default {
    props: {
        model: {
            type: Object,
            required: false,
        }
    },
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Menubar,
        DataTable,
        Column,
        Row,
        ColumnGroup,
        Button,
        InputText,
        InputNumber,
        AutoComplete,
        DeleteConfirmation,
    },
    data() {
        return {
            errors: {},
            payload: false,
            error: false,
        }
    },
    methods: {
        update() {
            this.payload = false;
            this.error = false;
            axios.post(this.route('api.settings.update'), this.model)
                .then((result) => {
                    this.payload = true;
                    window.scroll(0, 0);
                }).catch((error) => {
                    this.error = true;
                    window.scroll(0, 0);
                })
        },
        

        onFileChange(e) {
            e.preventDefault();

            let currentObj = this;

            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }

            let formData = new FormData();
            formData.append('file', e.target.files[0]);
            formData.append('type', 'oil');

            axios.post(this.route('api.settings.file'), formData, config)
                .then(function (response) {
                    currentObj.payload = true;
                    location.reload();
                })
                .catch(function (error) {
                    currentObj.error = true;
                    window.scroll(0, 0);
                });
        },

        onFile2Change(e) {
            e.preventDefault();

            let currentObj = this;

            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }

            let formData = new FormData();
            formData.append('file', e.target.files[0]);
            formData.append('type', 'dry');

            axios.post(this.route('api.settings.file'), formData, config)
                .then(function (response) {
                    currentObj.payload = true;
                    location.reload();
                })
                .catch(function (error) {
                    currentObj.error = true;
                    window.scroll(0, 0);
                });
        },
    }
}
</script>

<style scoped>
.file .pi {
    font-size: 24px;
}
</style>